import '@fortawesome/fontawesome-free/css/all.min.css';
import { StyledEngineProvider, ThemeProvider } from '@mui/material/styles';
import 'bootstrap-css-only/css/bootstrap.min.css';
import 'core-js';
import AppDynamicsInitializer from 'features/appdynamics/AppDynamicsInitializer';
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import App from './App';
import './assets/font/open-sans/OpenSans-Bold.ttf';
import './assets/font/open-sans/OpenSans-Regular.ttf';
import './assets/font/open-sans/OpenSans-Semibold.ttf';
import MUICustomTheme from './customTheme';
import './index.css';
import * as serviceWorker from './serviceWorker';
import { store } from './store/store';
import LocalStore from 'utils/LocalStore';

LocalStore.migrateLegacyParentDomainToken();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={MUICustomTheme}>
        <AppDynamicsInitializer />
        <App />
      </ThemeProvider>
    </StyledEngineProvider>
  </Provider>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
